<template>
<v-row>
    <v-dialog v-model="isVisible" absolute max-width="500" scrollable>
        <v-card>
            <v-form ref="form">
                <v-card-title class="primary-header pa-3">
                    오류 신고
                </v-card-title>
                <v-card-text class="pa-3">
                    <v-text-field label="년도" v-model="year" disabled></v-text-field>
                    <v-textarea label="내용" placeholder="오류 내용을 설명해주세요" v-model="content" :rules="contentRules"></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="report">신 고</v-btn>
                    <v-btn color="red" @click="close">닫 기</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</v-row>
</template>

<script>
import firebase from 'firebase/app'
import {
    db,
    auth
} from '@/firebase'
import { AccountToast } from '@/mixins/account-toast.js'

export default {
    name: 'report-dialog',
    mixins: [
        AccountToast
    ],
    data() {
        return {
            isVisible: false,
            year: '',
            content: '',
            contentRules: [
                v => {
                    if (!v) return '신고 내용을 입력해주세요'
                    if (v.length < 10) return '10자 이상 입력해야 합니다'
                    return true
                },
            ],
        }
    },
    computed: {
        user() {
            return this.$store.getters.user
        }
    },
    methods: {
        show(year) {
            this.year = year
            this.isVisible = true
        },
        async report() {
            if (!this.$refs.form.validate()) return

            try {
                await db.collection("reports").add({
                    queryUrl: this.$store.state.backTestUrl,
                    year: this.year,
                    content: this.content
                })

                this.$toasted.show("신고 감사합니다!")
            } catch (e) {
                this.showLoginToast()
            } finally {
                this.close()
            }

        },
        close() {
            this.isVisible = false
        },
    }
}
</script>
